export class LegListLoadFactor {
  constructor(public includeNonConfirmed: boolean = false) {}
}
